import { Column } from "@components/Layout";
import { AppViewWrapper } from "@layouts/App/styled";
import { styled } from "solid-styled-components";

export const TracklistViewWrapper = styled(AppViewWrapper)`
    @media only screen and (max-width: 512px) {
            padding: 10px 0 0;
            background: ${({ theme }) => theme?.colors.foreground};
            border-radius: 20px 20px 0 0;
    }
`;

export const DesktopTracksWrapper = styled(Column)`
    @media only screen and (max-width: 512px) {
        display: none;
    }
`;
